<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Send Money" :breadcrumb="breadcrumb"/>
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Confirm Transaction</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <Form @submit="sendCall">
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Email Address or Phone</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled  :value="$store.getters.getUserRequestSendMoneyData.user_account.user.email">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Amount</label>
                    <div class="col-sm-9">
                      <input type="text" class="form-control" disabled :value="$store.getters.getUserRequestSendMoneyData.amount / 100">
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-10">
                      <Button class="btn btn-primary" :loading="loader">Confirm</Button>
                      <Button class="btn btn-dark ml-1" type="button" @click="$router.push({name:'user-request-send-money-initiate'})">Back</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.transactionHash = this.$store.getters.getUserRequestSendMoneyHash
    // this.userGeneralInfoData = this.$store.getters.getUserGeneralInfoData
  },
  data(){
    return{
      loader: false,
      transactionHash: '',
      userGeneralInfoData : null,
      showModal: false,
      confirmationData:null,
      breadcrumb: [
        {name: 'App'},
        {name: 'User Request'},
        {name: 'Send Money'},
        {name: 'Confirm'},
      ],

    }
  },
  methods: {
    sendCall(){
      let data = {
        transactionHash : this.transactionHash,
        request_id : this.$store.getters.getUserRequestSendMoneyData.id,
      }
      this.loader = true
      this.makeRequest('post','v1/confirm-send-money',data).then(callResponse => {

        this.loader = false
        if(!callResponse.error){
          let code = callResponse.response.data.code;

          if(code == 200){
            if(typeof(callResponse.response.data.data.transactionId) != 'undefined'){
              this.confirmationData = callResponse.response.data.data
              this.showModal = true
            }
            this.emitter.emit("update-balance", true)
            this.$router.push({name: 'request-money'});
          }
          else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
  },
}
</script>

